import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [
        'modal',
        'patientId',
        'name',
        'birthday',
        'corporateCode',
        'userList',
        'userTableBody',
        'pagination',
        'paginationList',
        'selectedUserId',
        // PeraichiCsvDetail情報表示用のターゲットを追加
        'detailInfo',
        'detailLastName',
        'detailFirstName',
        'detailLastNameKana',
        'detailFirstNameKana',
        'detailBirthday',
        'detailGender',
        'detailCorporate',
        'detailReservationTime',
        'detailApplyDate',
        // ユーザー予約情報表示用
        'userReservationsContainer',
        'userReservationsTableBody',
        'selectedReservationId'  // 選択された予約IDを保持
    ]

    static values = {
        detailId: String,
        currentPage: { type: Number, default: 1 },
        perPage: { type: Number, default: 20 },
        totalPages: { type: Number, default: 1 }
    }


    connect(){
        document.addEventListener('link-modal:open',this.handleOpen.bind(this))
    }
    disconnect() {
        // イベントリスナーを削除（メモリリーク防止）
        document.removeEventListener('link-modal:open', this.handleOpen.bind(this))
    }
    handleOpen(event) {
        const { detailId } = event.detail
        this.detailIdValue = detailId
        this.currentPageValue = 1
        this.modalTarget.classList.add('is-active')
        // PeraichiCsvDetailの情報を取得して表示
        this.fetchDetailInfo()
    }
    close(){
        this.modalTarget.classList.remove('is-active')
        this.resetForm()
    }

    resetForm() {
        this.patientIdTarget.value = ''
        this.nameTarget.value = ''
        this.birthdayTarget.value = ''
        this.corporateCodeTarget.selectedIndex = 0
        this.userTableBodyTarget.innerHTML = ''
        this.userReservationsTableBodyTarget.innerHTML = ''
        this.userReservationsContainerTarget.style.display = 'none'
        this.currentPageValue = 1
        this.selectedUserIdTarget.value = ''
    }
    // PeraichiCsvDetailの情報を取得
    fetchDetailInfo() {
        fetch(`/admin/peraichi_csv_details/${this.detailIdValue}`, {
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.json())
            .then(data => {
                this.displayDetailInfo(data.detail)
                console.log(data.detail)
                // duplicated_user_idを保存
                const duplicatedUserId = data.detail.duplicated_user_id;
                this.fetchUsers().then(()=>{
                    if(duplicatedUserId){
                        const userRadio = this.userTableBodyTarget.querySelector(`input[value="${duplicatedUserId}"]`);
                        // ユーザーが見つかった場合、選択状態にする
                        if (userRadio) {
                            userRadio.checked = true;
                            this.selectedUserIdTarget.value = duplicatedUserId;
                            this.fetchUserReservations(duplicatedUserId);
                        }
                    }
                })
            })
            .catch(error => console.error('Error:', error))
    }

    // PeraichiCsvDetailの情報を表示
    displayDetailInfo(detail) {
        this.detailLastNameTarget.textContent = detail.last_name || ''
        this.detailFirstNameTarget.textContent = detail.first_name || ''
        this.detailLastNameKanaTarget.textContent = detail.last_name_kana || ''
        this.detailFirstNameKanaTarget.textContent = detail.first_name_kana || ''
        this.detailBirthdayTarget.textContent = detail.birthday ? new Date(detail.birthday).toLocaleDateString('ja-JP') : ''
        this.detailGenderTarget.textContent = detail.gender_name || ''
        this.detailCorporateTarget.textContent = detail.corporate_name || ''
        this.detailReservationTimeTarget.textContent = (detail.apply_reservation_time || '') + ' - ' + detail.peraichi_status
        this.detailApplyDateTarget.textContent = detail.apply_date ? detail.apply_date : ''

        // 検索フォームに値をセット（簡易検索用）
        this.nameTarget.value = `${detail.last_name_kana}`

    }

    search(event) {
        event.preventDefault()
        this.currentPageValue = 1
        this.fetchUsers()
    }

    fetchUsers() {
        const params = new URLSearchParams({
            page: this.currentPageValue,
            patients_id: this.patientIdTarget.value,
            name: this.nameTarget.value,
            birthday: this.birthdayTarget.value,
            corporate_code: this.corporateCodeTarget.value
        })

        return fetch(`/admin/health_check_users/search_for_link?${params.toString()}`, {
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.json())
            .then(data => {
                this.renderUsers(data.users)
                this.totalPagesValue = data.total_pages
                this.renderPagination()
                return data;
            })
            .catch(error => console.error('Error:', error))
    }
    renderUsers(users) {
        this.userTableBodyTarget.innerHTML = ''

        if (users.length === 0) {
            const tr = document.createElement('tr')
            tr.innerHTML = '<td colspan="8" class="has-text-centered">該当するユーザーがいません</td>'
            this.userTableBodyTarget.appendChild(tr)
            return
        }

        users.forEach(user => {
            const tr = document.createElement('tr')
            tr.innerHTML = `
                <td>
                    <div class="control">
                        <input type="radio" name="selected_user" value="${user.id}" 
                               data-action="click->admin--health-check-reservations--link#selectUser">
                    </div>
                </td>
                <td>${user.patients_id || ''}</td>
                <td>${user.last_name} ${user.first_name}</td>
                <td>${user.last_name_kana} ${user.first_name_kana}</td>
                <td>${user.gender_name}</td>
                <td>${user.birthday ? new Date(user.birthday).toLocaleDateString('ja-JP') : ''}</td>
                <td>${user.corporate_name || ''}</td>
                <td>${user.employee_number || ''}</td>
            `
            this.userTableBodyTarget.appendChild(tr)
        })
    }
    renderPagination() {
        this.paginationListTarget.innerHTML = ''

        // 前後ページボタンの有効/無効設定
        const prevButton = this.paginationTarget.querySelector('.pagination-previous')
        const nextButton = this.paginationTarget.querySelector('.pagination-next')

        prevButton.disabled = this.currentPageValue <= 1
        nextButton.disabled = this.currentPageValue >= this.totalPagesValue

        // ページネーションリンクの生成
        for (let i = 1; i <= this.totalPagesValue; i++) {
            const li = document.createElement('li')
            const a = document.createElement('a')

            a.classList.add('pagination-link')
            if (i === this.currentPageValue) {
                a.classList.add('is-current')
            }

            a.setAttribute('aria-label', `Page ${i}`)
            a.dataset.page = i
            a.textContent = i
            a.dataset.action = 'click->admin--health-check-reservations--link#goToPage'

            li.appendChild(a)
            this.paginationListTarget.appendChild(li)
        }
    }

    previousPage(event) {
        event.preventDefault()
        if (this.currentPageValue > 1) {
            this.currentPageValue--
            this.fetchUsers()
        }
    }

    nextPage(event) {
        event.preventDefault()
        if (this.currentPageValue < this.totalPagesValue) {
            this.currentPageValue++
            this.fetchUsers()
        }
    }

    goToPage(event) {
        event.preventDefault()
        this.currentPageValue = parseInt(event.currentTarget.dataset.page)
        this.fetchUsers()
    }

    selectUser(event) {
        const userId = event.target.value
        this.selectedUserIdTarget.value = userId
        this.fetchUserReservations(userId)
    }

    // ユーザーの予約情報を取得する関数
    fetchUserReservations(userId) {
        fetch(`/admin/health_check_users/${userId}/reservations`, {
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.json())
            .then(data => {
                this.renderUserReservations(data.reservations)
            })
            .catch(error => console.error('Error:', error))
    }

    // 予約情報を表示する関数
    renderUserReservations(reservations) {
        // 予約情報コンテナを表示
        this.userReservationsContainerTarget.style.display = 'block'

        // テーブルボディをクリア
        this.userReservationsTableBodyTarget.innerHTML = ''

        if (reservations.length === 0) {
            const tr = document.createElement('tr')
            tr.innerHTML = '<td colspan="8" class="has-text-centered">予約情報がありません</td>'
            this.userReservationsTableBodyTarget.appendChild(tr)
            return
        }

        // 予約情報を表示
        reservations.forEach(reservation => {
            const tr = document.createElement('tr')

            // 予約日のフォーマット
            const reservationDate = reservation.reservation_date ?
                new Date(reservation.reservation_date).toLocaleDateString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit'}).replace(/\//g, '/') :
                '';

            // 予約時間のフォーマット
            const reservationTime = reservation.reservation_time ?
                reservation.reservation_time.substring(0, 5) :
                '';
            console.log(reservation.disp_options)
            tr.innerHTML = `
            <td>
                <button class="button is-small is-info" 
                    data-action="click->admin--health-check-reservations--link#confirmLink"
                    data-reservation-id="${reservation.id}"
                    data-has-link="${reservation.peraichi_csv_detail_id ? 'true' : 'false'}"
                    >紐づけ</button>
                    
            </td>
            <td><a href="/admin/health_check_users/${reservation.health_check_user_id}" target="_blank">${reservation.scheduled_month}</a></td>
            <td style="white-space: nowrap;">
               ${(reservation.peraichi_status && reservation.peraichi_status.trim()) ?
                `ID:${reservation.peraichi_csv_id ? `<a href="/admin/health_check_reservations/${reservation.peraichi_csv_id}" target="_blank">${reservation.peraichi_csv_detail_id}</a>` : ''} <br/>
                申込ステータス：${reservation.peraichi_status}<br/>        
                申込日時：${reservation.peraichi_apply_date}`
                : ''}
            </td>
            <td>${reservation.disp_reservation_date || ''}</td>
            <td>${reservation.disp_reservation_time || ''}</td>
            <td>${reservation.check_section}</td>
            <td style="white-space: nowrap;">${reservation.disp_options ? reservation.disp_options.join('<br/>') : ''}</td>
            <td>${reservation.disp_created_at}</td>
        `
            this.userReservationsTableBodyTarget.appendChild(tr)
        })
    }

// 予約選択時の処理
    confirmLink(event) {
        const reservationId = event.currentTarget.dataset.reservationId;
        const hasExistingLink = event.currentTarget.dataset.hasLink === 'true';

        let message = "この名簿上の予約と紐付けます。よろしいですか？";
        if (hasExistingLink) {
            message = "この名簿上の予約と紐付けます。現在紐づいてるペライチCSVとの紐付けは解除します。よろしいですか？";
        }

        if (confirm(message)) {
            this.linkReservation(reservationId);
        }
    }

    linkReservation(reservationId) {
        const peraichiCsvDetailId = this.detailIdValue;

        fetch(`/admin/health_check_reservations/${reservationId}/link_peraichi_csv_detail`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                peraichi_csv_detail_id: peraichiCsvDetailId
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    // 成功時の処理
                    alert("紐付けが完了しました");
                    this.close(); // モーダルを閉じる
                    window.location.reload();
                } else {
                    alert(data.message || "紐付けに失敗しました");
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert("エラーが発生しました: " + error.message);
            });
    }
    selectClear(event) {
        event.preventDefault();
        this.birthdayTarget.value = '';
    }


}